import { Reducer } from '@reduxjs/toolkit'

import {
  GET_NOTIFICATIONS_LOADING,
  GET_NOTIFICATIONS_SUCCESS,
  GET_NOTIFICATIONS_FAILURE,
  READ_NOTIFICATION,
  TActionTypes,
} from '../interface/actionTypes'
import { INotification } from '../interface/INotification'

interface INotificationState {
  list: null | INotification[]
  loading: boolean
  error: string
}

const initialState: INotificationState = {
  list: null,
  loading: false,
  error: '',
}

export const notificationReducer: Reducer<INotificationState, TActionTypes> = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case GET_NOTIFICATIONS_LOADING:
      return {
        ...state,
        loading: true,
      }
    case GET_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.payload.list,
      }
    case GET_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      }
    case READ_NOTIFICATION:
      return {
        ...state,
        list: (state.list || []).map(notification => {
          return {
            ...notification,
            read: notification.isRead || notification.id === action.payload.id,
          }
        }),
      }
    default:
      return state
  }
}
